import { createSelector } from 'reselect'

export const getNewBanner = createSelector(
  state => state && state.user && state.user.profile && state.user.profile.newBanner
    ? state.user.profile.newBanner
    : null,
  banner => banner
)
